export const SITE_LIST_VIEW_MODES = {
    list: 'list',
    map: 'map',
} as const;

export type SiteListViewMode = (typeof SITE_LIST_VIEW_MODES)[keyof typeof SITE_LIST_VIEW_MODES];
